// src/core/services/auth.service.ts
import api from "@/core/services/axios";
import type { Auth, TokenResponse } from "@/models";

export class AuthService {
  constructor(private readonly baseRoute = "/auth") {}

  async fetchToken(body: Auth): Promise<TokenResponse> {
    const res = await api.post<TokenResponse>(`${this.baseRoute}/token`, body);
    return res.data;
  }
}

export const authService = new AuthService();
